import { render } from "./CreateSparkKzCompany.vue?vue&type=template&id=066a0c62&scoped=true&ts=true"
import script from "./CreateSparkKzCompany.vue?vue&type=script&lang=ts"
export * from "./CreateSparkKzCompany.vue?vue&type=script&lang=ts"

import "./CreateSparkKzCompany.vue?vue&type=style&index=0&id=066a0c62&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066a0c62"]])

export default __exports__